import { Button, Modal } from '../../../components';
import { Text } from '../../../components/Text';
import { sendAllMessageStrings } from '../../../constants';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
};

export function SaveDraftModal({
    open,
    onClose,
    onConfirm,
    isLoading = false,
}: Props) {

    return (
        <Modal open={open} onClose={onClose}>
            <div>
                <Text bold className="text-lg mb-2">
                    {sendAllMessageStrings.drafts.saveModal.title}
                </Text>
                <Text className="text-neutral-600 mb-4">
                    {sendAllMessageStrings.drafts.saveModal.message}
                </Text>
            </div>
            <div className="flex gap-4">
                <Button
                    variant="outline"
                    onClick={onClose}
                    disabled={isLoading}
                    className="flex-1"
                >
                    {sendAllMessageStrings.drafts.saveModal.cancel}
                </Button>
                <Button
                    onClick={onConfirm}
                    disabled={isLoading}
                    loading={isLoading}
                    className="flex-1"
                >
                    {sendAllMessageStrings.drafts.saveModal.confirm}
                </Button>
            </div>
        </Modal>
    );
}
